import { render } from "./UserGoldList.vue?vue&type=template&id=f5b398d8"
import script from "./UserGoldList.vue?vue&type=script&lang=js"
export * from "./UserGoldList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__